import React from 'react';

const AdditionalInfo = () => {

  return <>
      <div>
        <span className="required fw-bold">* </span>
        <span>
          Maximum aperture count is 2000. Anything with 2000 or more apertures would have to be
          considered a <a href="/products/prototype-smt-stencils">Prototype SMT Stencil.</a>
        </span>
      </div>
    </>
}

export default AdditionalInfo;
